import { useScrollReveal } from '@/hooks/useScrollReveal';

const features = [
  {
    icon: 'ri-computer-line',
    title: 'Software de escritorio',
    desc: 'Interfaz completa para administradores con todas las herramientas de gestión.',
  },
  {
    icon: 'ri-smartphone-line',
    title: 'App móvil del lecturador',
    desc: 'El personal de campo reporta lecturas con foto del medidor desde su celular.',
  },
  {
    icon: 'ri-global-line',
    title: 'Portal web del afiliado',
    desc: 'Cada usuario consulta sus lecturas, pagos y deuda en tiempo real online.',
  },
];

export default function WhatIs() {
  const { ref: sectionRef, isVisible } = useScrollReveal<HTMLDivElement>();

  return (
    <section className="relative py-20 md:py-28 bg-background-50">
      <div className="w-full px-4 md:px-8 lg:px-12">
        <div ref={sectionRef} className="max-w-6xl mx-auto">
          {/* Header */}
          <div className={`text-center mb-16 transition-all duration-700 ${isVisible ? 'opacity-100 translate-y-0' : 'opacity-0 translate-y-6'}`}>
            <span className="inline-block px-4 py-1.5 rounded-full bg-accent-100 text-accent-800 text-sm font-semibold mb-4">
              Ecosistema completo
            </span>
            <h2 className="font-heading text-3xl md:text-4xl lg:text-5xl font-bold text-primary-900">
              ¿Qué es Acualys-Bo?
            </h2>
            <p className="mt-4 text-base md:text-lg text-foreground-600 max-w-2xl mx-auto leading-relaxed">
              Acualys-Bo no es solo un programa de escritorio. Es un <strong className="text-primary-700">ecosistema digital completo</strong> diseñado específicamente para la realidad de las cooperativas de agua en Bolivia.
            </p>
          </div>

          {/* Ecosystem cards */}
          <div className="grid grid-cols-1 md:grid-cols-3 gap-6 md:gap-8">
            {features.map((f, i) => (
              <div
                key={f.title}
                className={`group relative bg-background-50 border border-background-200 rounded-xl p-6 md:p-8 transition-all duration-500 hover:scale-[1.03] hover:border-accent-300 hover:shadow-lg cursor-default ${
                  isVisible ? 'opacity-100 translate-y-0' : 'opacity-0 translate-y-8'
                }`}
                style={{ transitionDelay: `${(i + 1) * 150}ms` }}
              >
                <div className="w-14 h-14 rounded-xl bg-primary-50 flex items-center justify-center mb-5 group-hover:bg-accent-50 transition-colors">
                  <i className={`${f.icon} text-2xl text-primary-600 group-hover:text-accent-600 transition-colors`} />
                </div>
                <h3 className="font-heading text-lg md:text-xl font-semibold text-foreground-900 mb-2">
                  {f.title}
                </h3>
                <p className="text-sm md:text-base text-foreground-600 leading-relaxed">
                  {f.desc}
                </p>
              </div>
            ))}
          </div>

          {/* Description paragraph */}
          <div className={`mt-14 md:mt-20 bg-primary-50 rounded-2xl p-6 md:p-10 transition-all duration-700 delay-500 ${isVisible ? 'opacity-100 translate-y-0' : 'opacity-0 translate-y-6'}`}>
            <div className="flex flex-col md:flex-row items-start gap-6">
              <div className="shrink-0 w-12 h-12 rounded-xl bg-accent-500 flex items-center justify-center">
                <i className="ri-water-flash-line text-xl text-white" />
              </div>
              <div>
                <h4 className="font-heading text-lg font-semibold text-primary-900 mb-2">
                  Diseñado para la realidad boliviana
                </h4>
                <p className="text-sm md:text-base text-foreground-600 leading-relaxed">
                  Desde la lecturación mensual hasta la emisión de recibos con QR, pasando por la administración de cortes, finanzas y la gestión de rutas en mapa. Acualys-Bo centraliza toda la operación de tu cooperativa en una sola plataforma intuitiva, <strong className="text-primary-700">adaptada al contexto local y con soporte en español</strong>. El sistema permite que tus afiliados consulten su historial de consumo y pagos online, y que tu personal de lecturación reporte desde el campo con fotos georreferenciadas.
                </p>
              </div>
            </div>
          </div>
        </div>
      </div>
    </section>
  );
}